import api from '../../api/nodeBackApi';

export const createCustomerWithoutPayment = async (paymentConfig) => {

  try {
    const response = await api.post('/api/management/customers/createWithoutPayment', paymentConfig);
    
    console.log('Efectuandose la configiguracion.');
    return response.data;
  } catch (error) {
    console.error("Error al configurar:", error);
    throw error;
  }
};